<template>
  <VPopupWidget
    :icon="$vuetify.icons.values.entities"
    :visible="menu"
    :set-expand="
      (v) => {
        menu = v
      }
    "
    bottom
    left
  >
    <template slot="title">{{ $t('title') }}</template>

    <template slot="content">
      <entity-field
        :selection="entityType"
        :entities="entities"
        :update-selection="
          (v) => {
            entityType = v
          }
        "
      />
    </template>

    <template slot="footer-actions">
      <v-btn small depressed @click="submit">{{ $t('select') }}</v-btn>
    </template>
  </VPopupWidget>
</template>

<script>
import { mapState, mapActions } from 'vuex'
import { NAMESPACE } from '../store'
import { VPopupWidget } from '@argon/app/components'
import EntityField from './EntityField'

export default {
  name: 'EntityTypeFilter',
  components: {
    VPopupWidget,
    EntityField
  },
  data: () => ({
    menu: false
  }),
  props: {
    entities: { type: Array, default: () => [] }
  },
  computed: {
    ...mapState(NAMESPACE, ['boardFilter']),
    entityType: {
      get() {
        return this.boardFilter
      },
      set(v) {
        this.setBoardTypeFilter(v)
      }
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listBoards', 'setBoardTypeFilter']),
    submit() {
      this.listBoards(this.boardFilter)
        .then(() => {
          this.menu = false
        })
        .catch(() => {})
    }
  }
}
</script>

<i18n>
{
  "en": {
    "entity": "@:labels.entity",
    "select": "@:labels.select",
    "title": "Select entity type"
  },
  "fr": {
    "entity": "@:labels.entity",
    "select": "@:labels.select",
    "title": "Choisir type d'entité"
  }
}
</i18n>
